(function (Drupal, $) {
  'use strict';

  function cookieHelper() {
    const statistics = $('input[value="statistics"]')
    const marketing = $('input[value="marketing"]')
    const all = statistics.add(marketing)
    const button = $('.eu-cookie-compliance-save-preferences-button')
    const orgText = button.text()

    all.each((index, elem) => {
      const $elem = $(elem)

      if (!$elem.hasClass('processed')) {
        $elem.addClass('processed')
        $elem.off('change.slide').on('change.slide', () => {
          if (statistics[0].checked || marketing[0].checked) {
            if (orgText === 'Akceptuję tylko niezbędne pliki cookie, potrzebne do działania witryny') {
              button.text('Zaktualizowana zgoda')
            } else {
              button.text('Updated Consent')
            }
          } else {
            button.text(orgText)
          }
        })
      }
    })
  }

  function linkProcessor () {
    const pathname = window.location.pathname;

    $('section#content a').each(function () {
      if ($(this).attr('href') === pathname) {
          $(this).addClass('is-active')
      }
    })

    $('a.back-link').off('click.back').on('click.back', function (event) {
      event.preventDefault()
      window.history.back()
    });
  }

  function localScrollSetup () {
    $.localScroll({
      hash: false,
      offset: -40
    });
  }

  function formHelper () {
    if ($('.contact__contact-webform .webform-confirmation').length > 0) {
      $('.contact__contact-webform').addClass('confirmation');
    }

    const fileUploads = $('.js-form-type-webform-document-file')

    fileUploads.each(function (fileUploadIndex, fileUploadElement) {
      const $fileUploadElement = $(fileUploadElement)
      const $deleteButton = $fileUploadElement.find('[name="files_remove_button"]')

      $fileUploadElement.find('.js-form-type-checkbox').each(function (checkboxIndex, checkboxElement) {
        const $element = $(checkboxElement)
        const label = $element.find('label')
        const input = $element.find('input')

        label.off('click').on('click', function (event) {
          event.preventDefault()
          input.attr('checked','checked')
          $deleteButton.eq(0).trigger('mousedown')
        })

      })
    })
  }

  function resetFormErrorsListener () {
    $('input, textarea').off('focus.listener').on('focus.listener', function () {
      $(this).removeClass('error')
    });

    $('.webform-image-file').off('click.listener').on('click.listener', function () {
      $(this).parent().removeClass('error')
    });
  }

  function mainMenu () {
    $('.menu-bar-mobile').on('click', function (e) {
      if ($('.main-menu-res-mobile').hasClass('show-view')) {
        $(this).removeClass('show-view');
        $('.main-menu-res-mobile').removeClass('show-view')
      }
      else {
        $(this).addClass('show-view');
        $('.main-menu-res-mobile').addClass('show-view')
      }
      e.stopPropagation()
    })

    $('.res-menu-close').on('click', function () {
      $('.main-menu-res-mobile').removeClass('show-view')
      $('.menu-bar-mobile').removeClass('show-view')
    });

    $('.main-menu-res-mobile li.menu-item .nav-plus').off().on('click', function () {
      if ($(this).hasClass('nav-minus') === false) {
        $(this).parent('li').find('> ul').slideDown()
        $(this).addClass('nav-minus')
      }
      else {
        $(this).parent('li').find('> ul').slideUp()
        $(this).removeClass('nav-minus')
      }
      return false
    });
  }

  function paragraphHeight() {
    $('.paragraph--type-link-graphical.paragraph--view-mode-full-width, ' +
      '.paragraph--type-link-graphical.paragraph--view-mode-half-width').each(function () {
      const $this = $(this)
      const innerHeight = $this.find('.group-text').outerHeight() + 60

      $this.css({minHeight: innerHeight})
    });

    $('.paragraph--type-link-graphical.paragraph--view-mode-half-width').matchHeight({ remove: true }).matchHeight({})
  }

  $(document).ready(function () {
    cookieHelper()
    mainMenu()
    localScrollSetup()
    paragraphHeight()
  })

  $(window).off('resize.gen').on('resize.gen', function () {
    paragraphHeight()
  })

  Drupal.behaviors.theme = {
    attach: function (context, settings) {
      linkProcessor()
      localScrollSetup()
      formHelper()
      resetFormErrorsListener()
    }
  }

})(Drupal, jQuery);
